import { createContext, useContext } from 'react';

interface MessageErrorData {
  errorOnSend: number;
  error_code?: number | null;
  error_message?: string | null;
  fromMe: boolean;
  isDeleted: boolean;
  isWhisper: boolean;
  errorHandled?: boolean;
  isAssistantError?: boolean;
  assistantName?: string;
  stage?: 'local' | 'remote';
  channel?: string;
  onRetry?: () => void;
  onDiscard?: () => void;
}

const MessageErrorContext = createContext<MessageErrorData | null>(null);

export const MessageErrorProvider = MessageErrorContext.Provider;
export const useMessageError = () => useContext(MessageErrorContext);
